<template>
  <div class="bodys" v-if="body_show">
    <div class="spell_top clearfix">
      <ul>
        <li class="on">
          <div class="spell_t spell_first">
            <img src="@a/spell.png" alt="" />
            <span></span>
          </div>
          <p>选择商品
            <br/>开团/参团</p>
        </li>
        <li v-if="info.mission" class="on">
          <div class="spell_t">
            <span></span>
            <img src="@a/spell.png" alt="" />
            <span></span>
          </div>
          <p>邀请好友
            <br/>参团</p>
        </li>
        <li v-else>
          <div class="spell_t">
            <span></span>
            <img src="@a/spell2.png" alt="" />
            <span></span>
          </div>
          <p>邀请好友
            <br/>参团</p>
        </li>
        <li>
          <div class="spell_t">
            <span></span>
            <img src="@a/spell3.png" alt="" />
            <span></span>
          </div>
          <p>添加班主任微信</p>
        </li>
        <li>
          <div class="spell_t">
            <span></span>
            <img src="@a/spell4.png" alt="" />
          </div>
          <p style="text-align: right">去上课</p>
        </li>
      </ul>
    </div>
    <div class="spell_main">
      <h2>课程名称： <span>{{info.name}}</span></h2>
      <h2>拼团价格： <span>¥{{info.missionPrice}}</span></h2>
      <h2 v-if="info.mission">拼团规则： <span> <b>{{time}}</b> 后自动结束 / {{info.missionNum}}人团</span></h2>
      <h2 v-else>拼团规则： <span>开团后24小时自动结束 / {{info.missionNum}}人团</span></h2>
    </div>
    <a class="pay" @click="card_show=true" v-if="info.mission">邀请好友来参团</a>
    <a class="pay" @click="signHandle('mission',1)" v-else>我要开团 ¥{{info.missionPrice}}</a>
    <p class="zyz">
      拼团须知
      <br/> 1.拼团是指由多人一起拼单购买的促销活动，通过拼单可以享受低价听课优惠；
      <br/> 2.在设置的拼团时限内找到满足人数的好友参加拼团，即可算拼团成功开始听课；
      <br/> 3.在拼团时限内没有满足拼团人数要求，即算作拼团失败，系统会自动在24小时内将您支付的钱款退回微信钱包；
      <br/> 4.注意：一旦开始拼团，在倒计时结束前，不支持原价购买和退款操作。
    </p>
    <div class="pop_img" v-show="card_show" @click="card_show=false"></div>
    <public-mobile ref="handle" @refiers="pullData" :train_pay="train_pay"></public-mobile>
  </div>
</template>
<script>
import {
  setMission
} from "@/api/training";
import {
  shareCon
} from "@/utils/wxconfig";
export default {
  data() {
      return {
        body_show: false,
        course_id: '',
        share: '',
        source: '',
        info: {},
        user: {},
        train_pay: {},
        card_show: false,
        time: null,
        type_obj: {}
      };
    },
    methods: {
      // 付款
      signHandle(type, mission_type) {
        this.train_pay = {
          share: this.share, //分享人ID
          source: this.source || '', //分享来源
          mission_id: this.info.missionId, //拼团ID
          mission_type: mission_type, //拼团状态0单独购买1创建拼团2参团
          type: type,
          course_id: this.course_id
        };
        setTimeout(() => {
          this.$refs.handle.pay_training();
        }, 200)

      },
      pullData() {
        this.course_id = this.$route.query.course_id;
        this.share = this.$route.query.share || 0;
        if(this.$route.query.source) {
          this.source = typeof this.$route.query.source == 'string' ? this.$route.query.source:this.$route.query.source[0];
        }
        this.$toast.loading({
          mask: true,
          message: "加载中..."
        });
        setMission({
            course_id: this.course_id
          })
          .then(data => {
            this.body_show = true;
            this.$toast.clear();
            // document.title = data.info.name;
            this.info = data.info;
            this.user = data.user;
            this.type_obj = {
              nickname: data.user.nickname,
              train_name: data.info.name,
              train_id: data.info.id,
              share: data.user.id
            };
            if (this.info.mission) {
              this.timeTostring();
            }
            shareCon("training", this, this.type_obj);
          });
      },
      // 当前时间的格式化字符串
      timeTostring() {
        if (this.info.surplusTime > 0) {
          this.sin = setInterval(() => {
            var secondTime = parseInt(this.info.surplusTime); // 秒
            var minuteTime = 0; // 分
            var hourTime = 0; // 小时
            if (secondTime > 60) { //如果秒数大于60，将秒数转换成整数
              //获取分钟，除以60取整数，得到整数分钟
              minuteTime = parseInt(secondTime / 60);
              //获取秒数，秒数取佘，得到整数秒数
              secondTime = parseInt(secondTime % 60);
              //如果分钟大于60，将分钟转换成小时
              if (minuteTime > 60) {
                //获取小时，获取分钟除以60，得到整数小时
                hourTime = parseInt(minuteTime / 60);
                //获取小时后取佘的分，获取分钟除以60取佘的分
                minuteTime = parseInt(minuteTime % 60);
              }
            }
            var result = ((secondTime < 10) ? "0" : "") + parseInt(secondTime);

            if (minuteTime > 0) {
              result = ((minuteTime < 10) ? "0" : "") + parseInt(minuteTime) + ":" + result;
            }
            if (hourTime > 0) {
              result = ((hourTime < 10) ? "0" : "") + parseInt(hourTime) + ":" + result;
            }
            this.time = result;
            this.info.surplusTime -= 1;
          }, 1000);
        } else {
          clearInterval(this.sin)
        }

      }
    },
    created() {
      this.pullData();
    },
    destroyed() {
      clearInterval(this.sin)
    }
};
</script>
<style lang="scss" scoped>
@import "@s/remChange.scss";
.bodys {
  text-align: center;
}

.spell_top {
  margin-top: 40px;
  padding: 0 40px;
  ul li {
    float: left;
    .spell_t {
      text-align: left;
      img {
        width: 80px;
      }
      span {
        width: 56px;
        height: 4px;
        background-color: #ccc;
        display: inline-block;
      }
    }
    .spell_first {
      margin-left: 10px;
    }
    p {
      line-height: 40px;
      color: #333;
      font-size: 27px;
      margin-top: 20px;
      text-align: center;
    }
  }
  ul li.on {
    .spell_t {
      span {
        background-color: #F57F17;
      }
    }
    p {
      color: #F57F17
    }
  }
}

.spell_main {
  margin: 0 30px;
  margin-top: 50px;
  padding: 20px 0;
  border-top: 2px solid #666;
  border-bottom: 2px solid #666;
  text-align: left;
  line-height: 40px;
  h2 {
    font-size: 26px;
    color: #666;
    span {
      color: #333;
      b {
        color: #EB5032
      }
    }
  }
}

.pop_img {
  width: 100%;
  height: 100%;
  z-index: 100001;
  position: fixed;
  top: 0;
  left: 0;
  background: url(../../../assets/popse.png) no-repeat top center;
  background-size: cover;
}

.pay {
  display: block;
  width: 578px;
  height: 80px;
  background: rgba(235, 80, 50, 1);
  border-radius: 8px;
  margin: 0 auto;
  margin-top: 220px;
  color: #fff;
  font-size: 34px;
  line-height: 80px;
  margin-bottom: 60px;
}

.zyz {
  color: #666;
  font-size: 26px;
  line-height: 40px;
  text-align: justify;
  padding: 0 30px;
}
</style>
